// extracted by mini-css-extract-plugin
module.exports = {"main":"BBPicture_main__1QcsH","list":"BBPicture_list__3DSqp","firstItemBold":"BBPicture_firstItemBold__2iyh7","link":"BBPicture_link__3slHV"};